import { supabase } from "@/services/supabase/createClient";
import { useQuery } from "@tanstack/react-query";

export const getNotifications = async () => {
  const { data, error } = await supabase.from("notifications").select("*").eq("active", true);

  if (error) {
    throw error;
  }

  return data;
};

export const useNotifications = () => {
  return useQuery({
    queryKey: ["notifications"],
    queryFn: () => getNotifications(),
  });
};
